export const getCollections = state => state.collections.data;

export const isCollectionsFetching = state => state.collections.isFetching;

export const areCollectionsLoaded = state => state.collections.isLoaded;
